import { getSiblings } from "./utils";

const classNames = {
  CONTROL_ACTIVE: `screen-pictures__control--active`,
  PICTURE_VISIBLE: `screen-pictures__item--visible`,
  TITLE_VISIBLE: `screen__title--visible`,
};

export const setGalleryToggler = (e) => {
  const currentToggle = e.currentTarget;
  const type = currentToggle.dataset.id;

  const currentPicture = currentToggle
    .closest(`.screen-pictures`)
    .querySelector(`.screen-pictures__item[data-id='${type}']`);
  const currentTitle = currentToggle
    .closest(`.screen`)
    .querySelector(`.screen__title[data-id='${type}']`);

  const award = currentToggle.closest(`.screen`).querySelector(`.flats__award`);
  if (type === "loft" && award) {
    award.classList.add("visible");
  } else {
    if (award) {
      award.classList.remove("visible");
    }
  }

  const pictures = getSiblings(currentPicture);
  const toggles = getSiblings(currentToggle);
  let titles;

  currentToggle.classList.add(classNames.CONTROL_ACTIVE);
  toggles.forEach((toggle) =>
    toggle.classList.remove(classNames.CONTROL_ACTIVE)
  );

  currentPicture.classList.add(classNames.PICTURE_VISIBLE);
  pictures.forEach((picture) =>
    picture.classList.remove(classNames.PICTURE_VISIBLE)
  );

  if (currentTitle) {
    titles = getSiblings(currentTitle);

    currentTitle.classList.add(classNames.TITLE_VISIBLE);
    titles.forEach((title) => title.classList.remove(classNames.TITLE_VISIBLE));
  }
};
